import DireccionInputs from "common/components/FormikFields/DireccionInputs"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import { DEFAULT_COUNTRY_SELECTED } from "common/constants/countries"
import useSearchEmpresa from "common/hooks/useSearchEmpresa"
import { useTranslation } from "react-i18next"

const FormDatosBasicos = ({ values, setFieldValue }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { searchingEmpresa } = useSearchEmpresa({
    onSearchEmpresa: (empresa: $TSMigrationFixMe) => {
      setFieldValue("direccion", empresa.direccion?.calle)
      setFieldValue("cp", empresa.direccion?.codigoPostal)
      setFieldValue("poblacion", empresa.direccion?.poblacionNombre)
      setFieldValue("poblacionId", empresa.direccion?.poblacionId)
      setFieldValue("provinciaId", empresa.direccion?.provinciaId)
      setFieldValue("provincia", empresa.direccion?.provincia)
    },
  })

  return (
    <>
      <div className='mb-2 crear-contacto__subtitle'>
        {t("contactos.crear.labelDataBasic")}
      </div>
      <div className='p-fluid'>
        <div className='p-field'>
          <label htmlFor='direccion'>
            {t("contactos.crear.labelFiscalDirection")}
          </label>

          <FormikInputText
            disabled={searchingEmpresa}
            id='direccion'
            name='direccion'
          />
        </div>
      </div>

      <div className='tw-mt-4 tw-flex tw-flex-col lg:tw-flex-row lg:tw-space-x-2'>
        <DireccionInputs
          className='tw-text-left tw-w-full'
          disabled={searchingEmpresa}
          setFieldValue={setFieldValue}
          initialCodigoPostal={values.cp}
          otherCountries={values.codigoPais !== DEFAULT_COUNTRY_SELECTED}
          countrySelected={values.codigoPais}
          cpValue={values.cp}
          provinciaValue={values.provincia}
          poblacionValue={values.poblacion}
        />
      </div>
    </>
  )
}

export default FormDatosBasicos
